module.exports = __webpack_public_path__ + "static/chicken-a8663bd9532ea200c5e985bb8768d404.svg";